import React from "react";

import { Container } from "@components/Container/Container";

import styles from "./styles.module.scss";
import { Text } from "@components/Text/Text";
import { LinkField } from "@helpers/interfaces/link";
import { Link } from "@components/Link/Link";
import { Box } from "@components/Box/Box";
import { Icon } from "@components/Icon/Icon";
import arrowIcon from "@svg-icons/arrow.component.svg";
import Anime from "react-anime";
import { animeChildrenProps } from "@helpers/animations";
import { useInView } from "react-intersection-observer";

interface linkProps {
  Key: string;
  TopText: string;
  Link: LinkField;
}

export interface LinkListProps {
  linklist: linkProps[];
}

const LinkList: React.FC<LinkListProps> = ({ linklist, ...props }) => {
  const { ref, inView } = useInView({
    threshold: 0.2
  });
  const animateEachChild = {
    ...animeChildrenProps,
    ...(inView ? { autoplay: true } : { autoplay: false })
  };
  const linklistFilter = linklist.filter(link => link.Link);
  return (
    <div ref={ref} {...props}>
      <Container>
        <Box className={styles.linklist}>
          <Anime {...animateEachChild}>
            {linklistFilter &&
              linklistFilter.map((link: linkProps) => {
                if (!link.Link || !link.Link.Url) return null;
                return (
                  <Link
                    key={link.Key}
                    href={link.Link.Url}
                    {...(link.Link.Target && { target: link.Link.Target })}
                    className={styles.linklistLink}
                  >
                    <Text className={styles.section}>{link.TopText}</Text>
                    <Text className={styles.title}>{link.Link.Name}</Text>
                    <Icon svg={arrowIcon} className={styles.arrow} />
                  </Link>
                );
              })}
          </Anime>
        </Box>
      </Container>
    </div>
  );
};

export { LinkList };
